<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Publier une offre d'emploi
        </h1>
        <p class="text-white link-nav"><a *ngIf="userType == 'entreprise'" routerLink="/mes-offres-emploi">Mes Offres d'emploi </a> <a *ngIf="userType == 'admin'" routerLink="/admin/offres-emploi/0">Toutes les offres d'emploi </a><span
            class="lnr lnr-arrow-right"></span>
          <a routerLink="/admin/publier-offre-emploi"> Publier une offre d'emploi</a>
        </p>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Component new-job-offer -->

<app-new-job-offer></app-new-job-offer>

<!-- Component new-job-offer -->